module.exports = __webpack_public_path__ + "static/media/interact.8aa066ff.jpg";